var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef } from 'react';
import useTaroBaseEvents from '../_util/hooks/useTaroBaseEvents';
const Label = (_a, ref) => {
    var { for: htmlFor, children } = _a, rest = __rest(_a, ["for", "children"]);
    const handles = useTaroBaseEvents(rest);
    return (_jsx("label", Object.assign({ ref: ref, htmlFor: htmlFor }, handles, { children: children })));
};
export default forwardRef(Label);
